import Vue from "vue";
import Vuex from "vuex";
import {
  pos_settings,
  pos_Settings_getters,
  pos_Settings_setters,
} from "@/vuex/pos-settings";
import { modes, THEME_MODE } from "./theme";
import Socket from "@/modules/socket/Socket";

Vue.use(Vuex);

const getNotifications = () => {
  let notifications = {};
  let data = localStorage.getItem("notifications");
  if (data) {
    notifications = JSON.parse(data);
  }
  return notifications;
};
const getNotificationCount = () => {
  let c = 0;
  let data = localStorage.getItem("notifications");
  if (data) {
    c = Object.keys(JSON.parse(data)).length;
  }
  return c;
};

const formNotification = (info, sale) => {
  if (!info) {
    return;
  }
  let notification = JSON.parse(JSON.stringify(info));
  notification.token_no = sale.check_number;
  notification.id = `${Math.random().toString(36)}- ${+new Date()}`;
  notification.timestamp = +new Date();
  notification.ticket_name = sale.ticket_name;
  notification.store_name = sale.store_name;
  switch (notification.event_type) {
    case "KOT":
      notification.title = "KOT!";
      notification.message = `New KOT no: <strong>${
        notification.kot_number
      }</strong>, Table: <strong>${sale.table_name}</strong>`;
      notification.icon = "flaticon-fire-kot";
      notification.color = "purple";
      break;
    case "TRANSFER_ITEM":
      notification.title = "TRANSFER ITEM";
      notification.message = `Item transferred from table: <strong>${
        notification.from_table
      }</strong> to table: <strong>${notification.to_table}</strong>`;
      notification.icon = "flaticon-transfer";
      notification.color = "orange";
      break;
    default:
      notification.title = "Notification";
  }
  return notification;
};

const getNotificationConfig = (settings) => {
  let enable = false;
  let mute = true;
  if (settings && settings.nodeSettings) {
    enable = settings.nodeSettings.enableNotification;
    mute = !settings.nodeSettings.enableNotificationSound;
  }
  return { enable, mute };
};

var themeListener = null;
const onChangeTheme = (event) => {
  state.darkMode = event.matches;
};

const listenTheme = () => {
  removeListener();
  if (window.matchMedia) {
    themeListener = window.matchMedia("(prefers-color-scheme: dark)");
    themeListener.addEventListener("change", onChangeTheme);
    return themeListener.matches;
  }
  return false;
};

const removeListener = () => {
  if (themeListener) {
    themeListener.removeEventListener("change", onChangeTheme);
    themeListener = null;
  }
};

const getDefaultColumns = () => {
  const headers = [
    {
      text: "##",
      value: "index",
      align: "center",
      sortable: false,
      class: "clm1",
      enabled: true,
    },
    {
      text: "Kot #",
      value: "kot_number",
      align: "center",
      sortable: false,
      enabled: true,
    },
    {
      text: "Item",
      value: "menu_name",
      align: "left",
      sortable: false,
      class: "item-name-clm",
      enabled: true,
    },
    {
      text: "Qty",
      value: "quantity",
      align: "center",
      sortable: false,
      enabled: true,
    },
    {
      text: "Kot By",
      value: "kot_user_name",
      align: "center",
      sortable: false,
      enabled: true,
    },
    {
      text: "Kot Time",
      value: "kot_sent_time",
      align: "center",
      sortable: false,
      enabled: true,
    },
    {
      text: "Time",
      value: "time", // Assuming "time" will be dynamically calculated/displayed
      align: "center",
      sortable: false,
      enabled: true,
    },
    {
      text: "Status",
      value: "status",
      align: "right",
      sortable: false,
      class: "status-clm sticky-elm header",
      enabled: true,
    },
    {
      text: "Store Name",
      value: "store_name",
      align: "left",
      sortable: false,
      enabled: false,
    },
  ];

  return headers;
};

const state = {
  pos_settings: pos_settings,
  user: {},
  categories: {},
  cuisines: {},
  snackbar: {
    show: false,
    timeout: 0,
    color: "success",
    message: null,
    onStateChange: false,
  },
  tickets: {},
  notifications: getNotifications(),
  notificationCount: getNotificationCount(),
  selectedKitchenLine: null,
  darkMode: false,
  openAppUpdate: false,
  columns: null,
};

const getters = {
  tickets: (state) => {
    return state.tickets;
  },
  notifications: (state) => {
    return state.notifications;
  },
  getSelectedKitchen: (state) => {
    return state.selectedKitchenLine;
  },
  getNotificationCount: (state) => {
    return state.notificationCount;
  },
  isDarkMode(state) {
    return state.darkMode;
  },
  getNotificationConfig() {
    return getNotificationConfig(state.pos_settings);
  },
  openAppUpdate: (state) => state.openAppUpdate,
  getCheckViewColumns: (state) => {
    if (!state.columns || !state.columns.length) {
      state.columns = getDefaultColumns();
      // over ride selected
      const columns = localStorage.getItem("_columns");
      if (!columns || !Object.keys(columns).length) return state.columns;

      const selected = JSON.parse(columns);
      state.columns.forEach((c) => {
        c.enabled = selected[c.text] || false;
      });
    }
    return state.columns;
  },
  ...pos_Settings_getters,
};

const mutations = {
  setUserPrivileges(state, user) {
    state.isAdminUser = user.admin;
    state.user_privileges = user.privileges;
    localStorage.setItem("userId", user.id);
    localStorage.setItem("userName", user.name);
    localStorage.setItem(
      "privileges",
      JSON.stringify({
        isAdmin: state.isAdminUser,
        privileges: state.user_privileges,
      })
    );
  },
  showSnackbar(state, settings) {
    state.snackbar = {
      show: true,
      timeout: 3000,
      color: settings.color || "success",
      message: settings.message || "",
      onStateChange: settings.onStateChange || false,
    };
  },
  hideSnackbar(state) {
    state.snackbar = {
      show: false,
      message: "",
    };
  },
  setCuisines(state, cuisines) {
    state.cuisines = cuisines;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setTickets(state, tickets) {
    state.tickets = tickets;
  },
  updateTicket(state, resp) {
    let sale = resp.sale;
    Vue.set(state.tickets, sale.ticket_name, sale);

    let { enable, mute } = getNotificationConfig(state.pos_settings);
    if (enable) {
      let notification = formNotification(resp.notification, sale);
      if (notification) {
        state.notificationCount += 1;
        Vue.set(state.notifications, notification.id, notification);
        localStorage.setItem(
          "notifications",
          JSON.stringify(state.notifications)
        );
        if (!mute) {
          new Audio(require("@/assets/sound/kot.mp3")).play();
        }
      }
    }
  },
  removeTicketItem(state, resp) {
    console.log(state, "removeTicketItem");
    let ticket_name = resp.ticket_name;
    let item_uuid = resp.item.item_uuid;

    if (state.tickets[ticket_name] && state.tickets[ticket_name].items) {
      state.tickets[ticket_name].items = state.tickets[
        ticket_name
      ].items.filter((existingItem) => existingItem.item_uuid !== item_uuid);
    }

    let notifications = state.notifications;
    for (const id in notifications) {
      if (Object.hasOwnProperty.call(notifications, id)) {
        const element = notifications[id];
        if (
          element.ticket_name === ticket_name &&
          element.item_uuid === item_uuid
        ) {
          Vue.delete(state.notifications, id);
          if (state.notificationCount > 0) {
            state.notificationCount -= 1;
          }
        }
      }
    }
    localStorage.setItem("notifications", JSON.stringify(state.notifications));
  },
  removeTicket(state, ticket_name) {
    Vue.delete(state.tickets, ticket_name);
    let notifications = state.notifications;
    for (const id in notifications) {
      if (Object.hasOwnProperty.call(notifications, id)) {
        const element = notifications[id];
        if (element.ticket_name === ticket_name) {
          Vue.delete(state.notifications, id);
          if (state.notificationCount > 0) {
            state.notificationCount -= 1;
          }
        }
      }
    }
    localStorage.setItem("notifications", JSON.stringify(state.notifications));
  },
  setKitchenLine(state, kl) {
    state.selectedKitchenLine = kl;
    localStorage.setItem("kitchenLine", JSON.stringify(kl));
  },
  resetNotificationCount(state, val = 0) {
    state.notificationCount = val;
  },
  deleteNotification(state, id) {
    Vue.delete(state.notifications, id);
    if (state.notificationCount > 0) {
      state.notificationCount -= 1;
    }
    localStorage.setItem("notifications", JSON.stringify(state.notifications));
  },
  clearNotifications(state) {
    state.notifications = {};
    state.notificationCount = 0;
    localStorage.setItem("notifications", JSON.stringify(state.notifications));
  },
  setThemeMode(state, mode) {
    localStorage.setItem(THEME_MODE, mode);
    removeListener();
    switch (mode) {
      case modes.dark:
        state.darkMode = true;
        break;
      case modes.system:
        state.darkMode = listenTheme();
        break;
      default:
        state.darkMode = false;
    }
  },
  checkAppUpdate(state) {
    state.openAppUpdate = true;
  },
  closeAppUpdate(state) {
    state.openAppUpdate = false;
  },
  updateColumns: (state, columns) => {
    state.columns = columns;
    let selected = {};
    columns.forEach((c) => {
      if (c.enabled) {
        selected[c.text] = true;
      }
    });
    localStorage.setItem("_columns", JSON.stringify(selected));
  },
  ...pos_Settings_setters,
};

const actions = {
  setKitchenLine({ commit }, { kl }) {
    let storeId = localStorage.getItem("storeId");
    if (!storeId) {
      return;
    }
    if (!kl) {
      return;
    }
    commit("setKitchenLine", kl);

    let klStoreId = localStorage.getItem("klStoreId");
    if (!klStoreId) {
      klStoreId = storeId;
    }

    Socket.connectCh(
      {
        join: (tickets) => commit("setTickets", tickets),
        update: (resp) => commit("updateTicket", resp),
        remove: (ticket_name) => commit("removeTicket", ticket_name),
        removeItem: (resp) => commit("removeTicketItem", resp),
      },
      storeId,
      klStoreId,
      kl.id
    );
  },
  connectCh({ dispatch }) {
    let klData = localStorage.getItem("kitchenLine");
    if (klData) {
      let kl = JSON.parse(klData);
      dispatch("setKitchenLine", {
        kl,
      });
    }
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
